import { render, staticRenderFns } from "./InboxMultiple.vue?vue&type=template&id=2ff3b3f0"
import script from "./InboxMultiple.vue?vue&type=script&lang=js"
export * from "./InboxMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports